// Minutes are the backend's unit throughout; people read hours.
export function formatHours(minutes) {
  const n = Number(minutes) || 0;
  if (n === 0) return "—";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  if (!h) return `${sign}${m}m`;
  return m ? `${sign}${h}h ${m}m` : `${sign}${h}h`;
}

export const STATUS_COLOUR = {
  RECORDED: "warning",
  APPROVED: "success",
  REJECTED: "default",
};

/** A decision is final, so only a RECORDED entry can still be reviewed. */
export function isReviewable(entry) {
  return String(entry?.status || "").toUpperCase() === "RECORDED";
}

/**
 * Nobody approves their own overtime — the server refuses it, ADMIN included,
 * so the buttons go rather than being offered and refused.
 */
export function isOwnEntry(entry, myEmail, staffByEmail) {
  const me = staffByEmail?.get(String(myEmail || "").toLowerCase());
  return me != null && Number(me) === Number(entry?.staffId);
}

/** Totals for the queue header: what is waiting, and what it comes to. */
export function summarise(entries = []) {
  return entries.reduce(
    (acc, e) => {
      const mins = Number(e.minutes) || 0;
      const status = String(e.status || "").toUpperCase();
      acc.total += mins;
      if (status === "RECORDED") {
        acc.pending += 1;
        acc.pendingMinutes += mins;
      }
      if (status === "APPROVED") acc.approvedMinutes += mins;
      return acc;
    },
    { pending: 0, pendingMinutes: 0, approvedMinutes: 0, total: 0 }
  );
}
